import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translation files
import enTranslation from './locales/en/translation.json';
import faTranslation from './locales/fa/translation.json';
import arTranslation from './locales/ar/translation.json';

// Get saved language from localStorage or use default
const getSavedLanguage = () => {
  if (typeof window !== 'undefined') {
    try {
      const saved = localStorage.getItem('i18nextLng');
      if (saved && ['fa', 'en', 'ar'].includes(saved)) {
        return saved;
      }
    } catch (e) {
      console.warn('Error reading from localStorage:', e);
    }
  }
  return 'fa'; // Default to Persian
};

i18n
  .use(LanguageDetector)  // Detects user language
  .use(initReactI18next)   // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: enTranslation },
      fa: { translation: faTranslation },
      ar: { translation: arTranslation }
    },
    lng: getSavedLanguage(),  // Use saved language or default to Persian
    fallbackLng: 'fa',    // Fallback language if language detection fails
    interpolation: { escapeValue: false },  // React already escapes values
    detection: {
      // Order of detection methods - localStorage first to prioritize saved preference
      order: ['localStorage'],
      // Keys to lookup language from
      lookupLocalStorage: 'i18nextLng',
      // Cache user language in localStorage
      caches: ['localStorage'],
      // Don't check for cookie, querystring, or navigator
      lookupCookie: false,
      lookupQuerystring: false,
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      // Only use localStorage - don't detect from browser
      checkWhitelist: true
    }
  });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('i18nextLng', lng);
  }
});

export default i18n;
